import { jsx } from 'react/jsx-runtime';
import { clsx } from 'clsx';
import styles from './Text.module.css.js';

function Text({ variant = "body", prominence = "primary", align, weight = "base", lineheight = "base", accent = "none", truncate = false, nowrap = false, wordbreak = false, children, }) {
    return (jsx("span", { className: clsx(styles.Text, align !== undefined && [styles[align]], styles[prominence], styles[variant], styles[accent], {
            [styles.weightBase]: weight === "base",
            [styles.weightBold]: weight === "bold",
            [styles.weightBolder]: weight === "bolder",
            [styles.lineHeightBase]: lineheight === "base",
            [styles.lineHeightOne]: lineheight === "one",
            [styles.lineHeightNone]: lineheight === "none",
            [styles.truncate]: truncate,
            [styles.nowrap]: nowrap,
            [styles.wordBreak]: wordbreak,
        }), children: children }));
}

export { Text };
//# sourceMappingURL=Text.js.map
